import { createColumns } from '../utils'
import { ColumnDefinition, ColumnGroupDefinition } from '../types'
import type { WeekSummary } from '../../../../../../backend/src/services/resources/missions/missions.summary.service.types'
import { compareDocsById, getDocIdAsString } from '../../../../utils/documents'
import { formatDuration } from '../../../../utils/date'

export interface WorkerCountersColumnGroupProps {
  /** Distinct counter templates from week summary (two-parties rows) */
  counterTemplates: WeekSummary['counterTemplates']
  minimalMode?: boolean
}

/**
 * Week-level worker counter balances (one column per template), shown after costs and before actions.
 */
const workerCountersColumnGroup = ({
  counterTemplates,
  minimalMode = false,
}: WorkerCountersColumnGroupProps): ColumnGroupDefinition => {
  const columnDefs: ColumnDefinition[] = counterTemplates.map((template, index) => ({
    header: template.name,
    id: `counters.${getDocIdAsString(template._id)}`,
    shouldMerge: true,
    isHidden: minimalMode,
    className: index === counterTemplates.length - 1 ? 'table-section-end' : undefined,
    render: ({ counters }) => {
      const entry = counters?.find(c => compareDocsById(c.templateId, template._id))
      if (!entry) return '—'
      return formatDuration(entry.currentValue)
    },
  }))

  return {
    Header: 'Compteurs',
    id: 'Compteurs',
    columns: createColumns(columnDefs),
  }
}

export default workerCountersColumnGroup
